<mat-card appearance="outlined" class="flex-column">
  <mat-card-header class="flex-row-horizontal-space-between-vertical-center">
    <mat-card-title></mat-card-title>
    <div class="flex-row-horizontal-end-vertical-center">
      <button
        (click)="print()"
        class="icon-print"
        data-cy="button-print"
        i18n-matTooltip
        mat-icon-button
        matTooltip="Print"
        type="button"
      >
        <mat-icon>print</mat-icon>
      </button>
      <app-button-close></app-button-close>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div #printElement [innerHTML]="template" class="printable"></div>
  </mat-card-content>
</mat-card>
